import { LitElement, html, svg, unsafeCSS } from "lit"
import { customElement, property } from "lit/decorators.js"
import "./wordmark"
import styles from "./styles/logo-display.css?inline"
import { APP_VERSION } from "../firebase"

@customElement("start-page")
export class StartPage extends LitElement {
  @property({ type: Function }) onStart?: () => void
  @property({ type: Function }) onLearnMore?: () => void

  static styles = unsafeCSS(styles)

  private generateStars() {
    const stars: Array<{ x: number; y: number; r: number; opacity: number }> =
      []
    const starCount = 200

    for (let i = 0; i < starCount; i++) {
      stars.push({
        x: Math.random() * 100,
        y: Math.random() * 100,
        r: Math.random() * 1.5 + 0.5, // Smaller stars
        opacity: Math.random() * 0.6 + 0.4,
      })
    }

    // Add some larger, brighter stars
    for (let i = 0; i < 50; i++) {
      stars.push({
        x: Math.random() * 100,
        y: Math.random() * 100,
        r: Math.random() * 2 + 2, // Larger stars
        opacity: Math.random() * 0.4 + 0.6,
      })
    }

    return stars
  }

  private renderComet() {
    return svg`
      <svg class="comet" width="70" height="70" viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
        <!-- Tail going up and to the right, nucleus at bottom-left -->
        <!-- Tail end - greens (faint) -->
        <circle cx="65" cy="5" r="2" fill="#22c55e" opacity="0.15" />
        <circle cx="59" cy="11" r="2.5" fill="#22c55e" opacity="0.2" />
        <circle cx="53" cy="17" r="3" fill="#22c55e" opacity="0.25" />
        <!-- Transition to teals -->
        <circle cx="47" cy="23" r="3.5" fill="#1e9e7a" opacity="0.3" />
        <circle cx="41" cy="29" r="4" fill="#1a8a9e" opacity="0.35" />
        <!-- Blues -->
        <circle cx="35" cy="35" r="4.5" fill="#2563eb" opacity="0.4" />
        <circle cx="29" cy="41" r="5" fill="#3b82f6" opacity="0.45" />
        <circle cx="23" cy="47" r="5.5" fill="#60a5fa" opacity="0.5" />
        <!-- Light blues approaching nucleus -->
        <circle cx="17" cy="53" r="6" fill="#93c5fd" opacity="0.55" />
        <!-- Soft white nucleus -->
        <circle cx="11" cy="59" r="6" fill="#dbeafe" opacity="0.7" />
        <circle cx="11" cy="59" r="4" fill="#ffffff" opacity="0.8" />
      </svg>
    `
  }

  protected render() {
    const stars = this.generateStars()
    const currentYear = new Date().getFullYear()

    return html`
      <div class="start-root">
        <div class="stars-background">
          <div class="stars-background-inner">
            <svg xmlns="http://www.w3.org/2000/svg">
              ${stars.map(
                star => svg`
                <circle
                  cx="${star.x}%"
                  cy="${star.y}%"
                  r="${star.r}"
                  class="star"
                  opacity="${star.opacity}"
                />
              `
              )}
            </svg>
          </div>
        </div>
        <div class="comet-container">${this.renderComet()}</div>
        <div class="content-layer">
          <div class="logo-container">
            <app-wordmark .showTrademark=${true}></app-wordmark>
          </div>
          <div class="intro-container">
            <div class="intro-text">
              Telescope sighting for celestial objects with NASA ephemeris data
              and recommended viewing times.
            </div>
          </div>
          <div class="button-container">
            <button class="start-button" @click=${this.handleStart}>
              <div class="start-button-content">Start</div>
            </button>
          </div>
          <div class="learn-more-container">
            <button class="learn-more-button" @click=${this.handleLearnMore}>
              Learn More
            </button>
          </div>
          <div class="copyright">
            <div>
              <span class="copyright-text">Conjunction</span
              ><span class="copyright-number">1</span
              ><span class="copyright-text">
                &copy;${currentYear}
                <a
                  href="https://davidbethune.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="copyright-link"
                  >David Bethune</a
                >
                v${APP_VERSION}</span
              >
            </div>
          </div>
        </div>
      </div>
    `
  }

  private handleStart = () => {
    this.onStart?.()
  }

  private handleLearnMore = () => {
    this.onLearnMore?.()
  }
}
